<template>
  <div>
    <div class="row">
      <button class="col-md-2 ml-1 mb-1 btn btn-success" @click="exportToExcel" style="white-space: nowrap;">
        Exportar para Excel
      </button>
      <button class="col-md-2 ml-1 mb-1 btn text-content-right"
        :class="exibirVencidos ? 'btn-warning' : 'btn-secondary'" @click="toggleVencidos">
        {{ exibirVencidos ? 'Mostrar Todos' : 'Apenas Vencidos' }}
      </button>
      <button class="col-md-2 ml-1 mb-1 btn text-content-right"
        :class="mostrarQuantidadeZero ? 'btn-info' : 'btn-secondary'" @click="toggleQuantidadeZero">
        {{ mostrarQuantidadeZero ? 'Mostrar Todos' : 'Apenas Quantidade Zero' }}
      </button>

      <div class="col-md-12">
        <base-crud :key="tableKey" :ref="'estoquesCrud'" crudName="Estoques" newText="Novo Estoque" :table="table"
          :columns="columns" :options="options" :endPoint="endPoint" :enableAdd="false" :enableEdit="false"
          :enableDelete="false" :enableView="false" :enableReset="false" :dataForm="dataForm">
        </base-crud>
      </div>

      <div class="ibox-title" style="padding: 16px">
        <div class="modal fade" id="modalExport" tabindex="-1" role="dialog" aria-labelledby="modalExportTitle"
          aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">Exportar</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div class="modal-body mt-1">
                <div class="alert alert-warning" role="alert">
                  Para exportar todos os registros, basta não definir nenhum
                  intervalo de datas e proceder com a exportação.
                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"></button>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-1">
                    <label>Data de Ínicio</label>
                    <input type="date" class="form-control" v-model="filtros.data_inicio" />
                  </div>
                  <div class="col-md-6 mb-1">
                    <label>Data do Fim</label>
                    <input type="date" class="form-control" v-model="filtros.data_fim" />
                  </div>
                </div>
              </div>

              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">
                  Fechar
                </button>
                <button type="button" class="btn btn-primary" @click="exportToExcel">
                  Exportar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      mostrarQuantidadeZero: false, // Flag para controlar exibição de itens com quantidade 0
      filtros: {
        data_inicio: null,
        data_fim: null,
      },
      exibirVencidos: false,
      tableKey: 0,
      table: "estoquesTable",
      showMessageImport: false,
      usersCrud: {},
      pages: [],
      url: "",
      columns: [
        "id",
        "unidade_id",
        "material_id",
        "codigo",
        "lote",
        "fabricante_id",
        "fornecedor_id",
        "quantidade",
        "preco_medio",
        "validade_f",
        "tempo_para_vencer",
        "tipo_veiculos",
        "aba"
      ],
      tableData: [
        "id",
        "unidade_id",
        "material_id",
        "codigo",
        "fabricante_id",
        "fornecedor_id",
        "lote",
        "validade_f",
        "quantidade",
      ],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: [
          "id",
          "unidade_id",
          "material_id",
          "lote",
          "fabricante_id",
          "fornecedor_id",
          "tipo_veiculos",
          "aba",
        ],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          unidade_id: "Unidade",
          material_id: "Material",
          codigo: "Código",
          fabricante_id: "Fabricante",
          fornecedor_id: "Fornecedor",
          lote: "Lote",
          validade_f: "Validade",
          quantidade: "Quantidade",
          preco_medio: "Preço",
          tipo_veiculos: "Tipos de Veículo",
          aba: "Aba",
          actions: "Ações",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {},
        templates: {

          tempo_para_vencer: function (h, row) {
            return h('span', {
              domProps: { innerHTML: row.tempo_para_vencer } // 👈 renderiza o HTML vindo do backend
            });
          },
          unidade_id: function (h, row, index) {
            return row.unidade ? row.unidade.nome : "Indisponível";
          },
          material_id: function (h, row, index) {
            return row.material ? row.material.nome : "Indisponível";
          },
          codigo: function (h, row, index) {
            return row.material ? row.material.codigo : "Indisponível";
          },
          fabricante_id: function (h, row, index) {
            return row.fabricante
              ? row.fabricante.nome_fantasia
              : "Indisponível";
          },
          fornecedor_id: function (h, row, index) {
            return row.fornecedor
              ? row.fornecedor.nome_fantasia
              : "Indisponível";
          },
          tipo_veiculos: function (h, row, index) {
            if (row.material && row.material.tipo_veiculos && row.material.tipo_veiculos.length > 0) {
              const tipos = row.material.tipo_veiculos.map(tipo => tipo.nome).join(", ");
              return tipos;
            }
            return "N/A";
          },
          aba: function (h, row, index) {
            return row.material && row.material.tab ? row.material.tab.title : "N/A";
          },
        },
        requestFunction: function (data) {
          const self = this.$parent.$parent.$parent;
          let requestData = {};

          let query = self.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [
            "material",
            "material.tipo_veiculos",
            "material.tab",
            "unidade",
            "fabricante",
            "fornecedor",
          ];

          // Adicionar filtro de vencidos na requisição
          const componenteEstoque = this.$parent.$parent.$parent;
          console.log('Verificando exibirVencidos:', componenteEstoque.exibirVencidos);

          if (componenteEstoque.exibirVencidos) {
            requestData.params.apenas_vencidos = true;
            console.log('Enviando apenas_vencidos=true - vai mostrar APENAS vencidos');
          } else {
            console.log('Modo normal - mostra todos exceto vencidos');
          }          // Lógica do filtro de quantidade
          if (self.mostrarQuantidadeZero) {
            requestData.params.filtroQuantidade = "apenas_zero";
            console.log('Enviando apenas_zero=true - vai mostrar APENAS quantidade zero');
          } else {
            // No modo normal, não enviar filtro de quantidade (deixar o backend decidir)
            // requestData.params.filtroQuantidade = "maior_que_zero";
            console.log('Modo normal - sem filtro específico de quantidade');
          }

          console.log("Request Params:", {
            mostrarQuantidadeZero: self.mostrarQuantidadeZero,
            filtroQuantidade: requestData.params.filtroQuantidade,
            allParams: requestData.params,
          });

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "estoques",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    toggleQuantidadeZero() {
      this.mostrarQuantidadeZero = !this.mostrarQuantidadeZero;
      // Força o re-render completo da tabela alterando a key
      this.tableKey += 1;
      console.log('Toggle quantidade zero:', this.mostrarQuantidadeZero);
    },
    exportToExcel() {
      const self = this;
      const dataInicio = self.filtros.data_inicio;
      const dataFim = self.filtros.data_fim;

      // Construir parâmetros da URL
      let urlParams = [];

      // Adicionar filtros de data se existirem
      if (dataInicio && dataFim) {
        urlParams.push(`data_inicio=${dataInicio}`);
        urlParams.push(`data_fim=${dataFim} 23:59:59`);
      } else if (dataInicio || dataFim) {
        self.$message(
          null,
          "Por favor, preencha ambos os campos de data.",
          "error"
        );
        return;
      }

      // Lógica dos filtros - seguir exatamente o que está sendo exibido na tabela
      if (self.exibirVencidos) {
        // Filtro ativo: mostrar APENAS vencidos
        urlParams.push('apenas_vencidos=true');
      } else {
        // Modo normal: mostrar apenas NÃO vencidos
        urlParams.push('excluir_vencidos=true');
      }

      if (self.mostrarQuantidadeZero) {
        // Filtro ativo: mostrar APENAS quantidade zero
        urlParams.push('filtroQuantidade=apenas_zero');
      } else {
        // Modo normal: mostrar apenas quantidade > 0
        urlParams.push('filtroQuantidade=maior_que_zero');
      }

      // Construir URL final
      const baseUrl = `${self.$store.state.url}exportar_estoque`;
      const finalUrl = urlParams.length > 0 ? `${baseUrl}?${urlParams.join('&')}` : baseUrl;

      window.open(finalUrl, "_blank").focus();
    },
    toggleVencidos() {
      this.exibirVencidos = !this.exibirVencidos;
      // Força o re-render completo da tabela alterando a key
      this.tableKey += 1;
      console.log('Toggle vencidos:', this.exibirVencidos);
    },
    query: function (query) {
      let columns = {
        id: "id",
        material_id: "material[nome]",
        codigo: "material[codigo]",
        unidade_id: "unidade[nome]",
        fabricante_id: "fabricante[nome_fantasia]",
        fornecedor_id: "fornecedor[nome_fantasia]",
        lote: "lote",
        tipo_veiculos: "tipo_veiculos[nome]",
        aba: "aba[title]",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>
